import fileSelector from '../app/file_selector';

$(document).on('ready turbolinks:load', () => {
  fileSelector({
    uploadButton: $('#driver-photo'),
    idInput: $('input#driver_photo_resource_id'),
    type: 'driver_pics',
    button: $('button#save-driver-button'),
  });
  fileSelector({
    uploadButton: $('#driver-card-front'),
    idInput: $('input#driver_card_front_resource_id'),
    type: 'driver_licenses',
    button: $('button#save-driver-button'),
  });
  fileSelector({
    uploadButton: $('#driver-card-back'),
    idInput: $('input#driver_card_back_resource_id'),
    type: 'driver_licenses',
    button: $('button#save-driver-button'),
  });
});
